import contactGroups from 'collections/contactGroupsInstance';
import fetchOncePromise from 'libraries/fetchOncePromise';

const promise = fetchOncePromise(contactGroups);
promise.done((contactGroups) => {
    contactGroups.each(function(cg) { cg.fetchDomainsOnce(); });
});

export default promise;
